
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.316 24.736l14.58-6.28c6.943-2.888 8.385-3.39 9.326-3.406.206-.003.669.048.968.29.253.206.323.483.356.678.034.194.075.638.042.984-.376 3.953-2.004 13.546-2.832 17.974-.35 1.873-1.04 2.501-1.709 2.563-1.452.133-2.554-.96-3.96-1.881l-5.58-3.748c-2.468-1.627-.868-2.52.539-3.982.368-.382 6.765-6.2 6.889-6.728.015-.066.03-.312-.117-.442-.146-.13-.362-.085-.517-.05-.221.05-3.736 2.373-10.546 6.97-.997.685-1.901 1.019-2.71 1.001-.893-.019-2.61-.504-3.887-.92-1.566-.508-2.81-.777-2.701-1.642.056-.45.676-.91 1.86-1.38z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    